export default __webpack_public_path__ + "static/media/shogun.4245e19c.svg";